import * as i0 from '@angular/core';
import { Injectable, NgModule, EventEmitter } from '@angular/core';
import * as i1 from '@tajer/api';
import { CountryIso2Code } from '@tajer/api';
import { ReplaySubject, Subject } from 'rxjs';

class NgCoreService {
    constructor(addressService) {
        this.addressService = addressService;
        this.addressService;
    }
}
NgCoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreService, deps: [{ token: i1.AddressService }], target: i0.ɵɵFactoryTarget.Injectable });
NgCoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AddressService }]; } });

const environment = {
    googleAPI: ''
};

class NgCoreModule {
    static forRoot(config) {
        environment.googleAPI = config.googleAPI;
        return {
            ngModule: NgCoreModule,
            providers: []
        };
    }
}
NgCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule });
NgCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: []
                }]
        }] });

var ScriptLibraryType;
(function (ScriptLibraryType) {
    ScriptLibraryType["GOOGLE"] = "google.maps";
})(ScriptLibraryType || (ScriptLibraryType = {}));

const scriptLibs = [
    {
        name: ScriptLibraryType.GOOGLE,
        src: `https://maps.googleapis.com/maps/api/js?key=${environment.googleAPI}&libraries=places,drawing`
    },
];

class ScriptService {
    constructor() {
        this.scripts = new Map();
        scriptLibs.forEach(script => this.scripts.set(script.name, { ...script, loaded: false }));
    }
    load(...scripts) {
        const promises = [];
        scripts.forEach(script => promises.push(this.loadScript(script)));
        return Promise.all(promises);
    }
    updateScriptSrc(scriptLibraryType, src) {
        let selectedSecript = scriptLibs.find(script => script.name == scriptLibraryType);
        selectedSecript.src = src;
        const scriptOptions = this.scripts.get(scriptLibraryType);
        scriptOptions.src = src;
    }
    loadScript(name) {
        const scriptOptions = this.scripts.get(name);
        return new Promise((resolve, reject) => {
            //resolve if already loaded
            if (scriptOptions.loaded) {
                resolve({ script: name, loaded: true, status: 'Loaded' });
            }
            else {
                //load script
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = scriptOptions.src;
                if (script.readyState) { //IE
                    script.onreadystatechange = () => {
                        if (script.readyState === 'loaded' || script.readyState === 'complete') {
                            script.onreadystatechange = null;
                            scriptOptions.loaded = true;
                            resolve({ script: name, loaded: true, status: 'Loaded' });
                        }
                    };
                }
                else { //Others
                    script.onload = () => {
                        scriptOptions.loaded = true;
                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    };
                }
                script.onerror = error => resolve({ script: name, loaded: false, status: 'Loaded' });
                console.log(script);
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }
}
ScriptService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ScriptService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ScriptService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ScriptService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ScriptService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/* eslint-disable @typescript-eslint/naming-convention */
// GoogleMap Types
/// <reference types="@types/googlemaps" />
//#region Regex
//regex latitude and longitude -90.26365 +90.12343
const REGEX_LONG_LAT = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/g;
//regex {premise} with frequency
const REGEX_BRACKETS_GLOBAL = /{[a-z0-9]+(?:_[a-z0-9]+)*}/g;
//regex remove all brackets {}
const REGEX_WITHOUT_BRACKETS = /[{}]/g;
//regex {premise} without frequency
const REGEX_BRACKETS = /{[a-z0-9]+(?:_[a-z0-9]+)*}/;
//regex , spaces {premise}
const REGEX_BEFORE_COMMON_BRACKET = /(,)*(\s)*{[a-z0-9]+(?:_[a-z0-9]+)*}/;
//regex {premise} , spaces
const REGEX_AFTER_COMMON_BRACKET = /{[a-z0-9]+(?:_[a-z0-9]+)*}(\s)*(,)*/;
//#endregion
//#region Options
const CIRCLE_OPTIONS = {
    strokeColor: '#ff8c8c',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#ff8c8c',
    fillOpacity: 0.35
};
//#endregion
class GoogleMapsAppService {
    //#endregion
    constructor(scriptService) {
        this.scriptService = scriptService;
        this.isLibLoaded$ = new ReplaySubject();
        this.somethingWrongAlert$ = new Subject();
        this.all_zoneOverlays = [];
        this.all_zonePolygons = [];
        this.mapZonePointList$ = new Subject();
    }
    //#region Get & Set
    init(googleAPI) {
        if (googleAPI) {
            environment.googleAPI = googleAPI;
        }
        let src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleAPI}&libraries=places,drawing`;
        this.scriptService.updateScriptSrc(ScriptLibraryType.GOOGLE, src);
        this.loadLibrary().then(() => {
            this.map = null;
            this.elementHtml = null;
            this.address = { target: null };
            this.markers = [];
            this.circles = [];
            this.countries = [];
            this.isCoordinatesSearch = false;
            this.geocoder = new google.maps.Geocoder();
            this.isLoading = new EventEmitter();
            this.isMapOpened = new EventEmitter();
            this.googleAutocompleteService = new google.maps.places.AutocompleteService();
            this.resultsSearched = new EventEmitter();
            this.isLibLoaded$.next(true);
        });
    }
    setWithZone(withZone) {
        this.withZone = withZone;
    }
    isWithZone() {
        return this.withZone;
    }
    setCountries(countries) {
        this.countries = countries.slice();
    }
    getCountries() {
        return this.countries.slice();
    }
    getAddressDto() {
        return this.address;
    }
    getResultsSearched() {
        return this.resultsSearched.asObservable();
    }
    setResultsSearched(results) {
        this.resultsSearched.next(results);
    }
    getLoadingResults() {
        return this.isLoading.asObservable();
    }
    setLoadingResults(value) {
        return this.isLoading.next(value);
    }
    getMapLoaded() {
        return this.isMapOpened.asObservable();
    }
    setMapLoaded(value) {
        this.isMapOpened.next(value);
    }
    setMapDOM(htmlElement) {
        this.elementHtml = htmlElement;
    }
    loadLibrary() {
        return this.scriptService.load(ScriptLibraryType.GOOGLE);
    }
    getLibraryStatus() {
        return this.isLibLoaded$;
    }
    setLibraryLoaded(val) {
        this.isLibLoaded$.next(val);
    }
    //#endregion
    //#region Map
    initialMap() {
        this.setMapLoaded(true);
        this.map = new google.maps.Map(this.elementHtml);
        if (this.withZone) {
            this.addDrawingManager();
        }
        this.map.addListener('click', e => {
            this.resetCircles();
            this.addMarker(e.latLng);
        });
        this.displayMap();
    }
    viewMapWithPosition(latLng, accuracy = null, htmlElement, markerInfoWindowContent) {
        const position = new google.maps.LatLng(latLng.lat, latLng.lng);
        this.map = new google.maps.Map(htmlElement);
        this.map.setOptions({
            draggable: false,
            zoomControl: false,
            scrollwheel: false,
            disableDoubleClickZoom: true
        });
        this.map.setCenter(position);
        this.map.setZoom(this.withZone ? 10 : 19);
        let marker = new google.maps.Marker({ position, map: this.map });
        if (markerInfoWindowContent && markerInfoWindowContent.length > 0) {
            this.addMarkerInfoWindow(marker, markerInfoWindowContent);
        }
        this.addCircle(position, accuracy);
    }
    addMarkerInfoWindow(marker, message) {
        var infoWindow = new google.maps.InfoWindow({
            content: message
        });
        google.maps.event.addListener(marker, 'mouseover', function () {
            infoWindow.open(this.map, marker);
        });
    }
    addMarker(position) {
        this.resetMap();
        const marker = new google.maps.Marker({
            draggable: true,
            animation: google.maps.Animation.DROP,
            position,
            map: this.map
        });
        // Event Dragend
        google.maps.event.addListener(marker, 'dragend', evt => {
            this.resetCircles();
            this.geoCoderLatLang(evt.latLng);
        });
        this.geoCoderLatLang(marker.getPosition());
        this.map.setZoom(this.withZone ? 10 : 19);
        this.markers.push(marker);
        this.map.setCenter(position);
    }
    addCircle(position, accuracy) {
        const circle = new google.maps.Circle({
            ...CIRCLE_OPTIONS,
            map: this.map,
            center: position,
            radius: accuracy
        });
        this.circles.push(circle);
        this.address.accuracy = accuracy;
    }
    /**
     * create map with zone drawer
     * @param htmlElement
     * @param mapZonePointList
     */
    viewMapWithZone(htmlElement, mapZonePointList) {
        if (mapZonePointList && mapZonePointList.length > 0) {
            this.map = new google.maps.Map(htmlElement);
            this.map.setCenter(mapZonePointList[0]);
            this.map.setZoom(this.withZone ? 10 : 19);
            // Construct the polygon.
            this.zonePolygon = new google.maps.Polygon({
                paths: mapZonePointList,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 3,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                editable: true,
                clickable: true,
                draggable: true
            });
            this.zonePolygon.setMap(this.map);
            //this.all_zonePolygons.push(this.zonePolygon);
            ['dragstart', 'drag', 'dragend', 'click'].forEach((eventName) => {
                this.zonePolygon.addListener(eventName, () => {
                    this.mapZonePointList$.next(this.getMapZonePointList());
                });
            });
            var place_polygon_path = this.zonePolygon.getPath();
            google.maps.event.addListener(place_polygon_path, 'set_at', () => {
                this.mapZonePointList$.next(this.getMapZonePointList());
            });
            google.maps.event.addListener(place_polygon_path, 'insert_at', () => {
                this.mapZonePointList$.next(this.getMapZonePointList());
            });
            this.addDrawingManager();
        }
        else {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(async (position) => {
                    const location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    this.map = new google.maps.Map(htmlElement);
                    this.map.setCenter(location);
                    this.map.setZoom(this.withZone ? 10 : 19);
                    this.addDrawingManager();
                }, (e) => {
                    //view Full map if user denied access to his location
                    this.map = new google.maps.Map(htmlElement);
                    this.map.setCenter({ lat: 55.5815245, lng: 36.8251383 });
                    this.map.setZoom(3);
                    this.addDrawingManager();
                    this.somethingWrongAlert$.next(e.message);
                }, {
                    enableHighAccuracy: true
                });
            }
            else {
                this.somethingWrongAlert$.next('BrowserNotSupported');
            }
        }
    }
    //#endregion
    //#region APIs
    /**
     * draw a polygon tool; with many listners
     */
    addDrawingManager() {
        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [google.maps.drawing.OverlayType.POLYGON]
            },
            polygonOptions: {
                draggable: true,
                editable: true,
            },
        });
        this.drawingManager.setMap(this.map);
        google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
            // Polygon drawn
            if (event.type === google.maps.drawing.OverlayType.POLYGON) {
                //this is the coordinate, you can assign it to a variable or pass into another function.
                this.zonePolygon?.setMap(null);
                this.deleteAllDrawers();
                let polygon = new google.maps.Polygon({
                    paths: event.overlay.getPath(),
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                    fillColor: '#FF0000',
                    fillOpacity: 0.35,
                    editable: true,
                    clickable: true,
                    draggable: true
                });
                polygon.setMap(this.map);
                this.zonePolygon = polygon;
                this.mapZonePointList$.next(this.getMapZonePointList());
                ['dragstart', 'drag', 'dragend', 'click'].forEach((eventName) => {
                    polygon.addListener(eventName, () => {
                        this.mapZonePointList$.next(this.getMapZonePointList());
                    });
                });
                var place_polygon_path = polygon.getPath();
                google.maps.event.addListener(place_polygon_path, 'set_at', () => {
                    this.mapZonePointList$.next(this.getMapZonePointList());
                });
                google.maps.event.addListener(place_polygon_path, 'insert_at', () => {
                    this.mapZonePointList$.next(this.getMapZonePointList());
                });
                this.all_zoneOverlays.push(event);
                this.all_zonePolygons.push(polygon);
                event.overlay.setMap(null);
                //alert(event.overlay.getPath().getArray());
            }
        });
    }
    getMapZonePointList() {
        let polygon_pointList = [];
        const len = this.zonePolygon?.getPath()?.getLength();
        for (let i = 0; i < len; i++) {
            polygon_pointList.push(this.zonePolygon.getPath().getAt(i).toJSON());
        }
        return polygon_pointList;
    }
    /**
     * in order to delete the drawers shapes
     */
    deleteAllDrawers() {
        this.all_zoneOverlays.forEach(overlayItem => {
            overlayItem.overlay.setMap(null);
        });
        this.all_zonePolygons.forEach(polygon => {
            polygon.setMap(null);
        });
        this.all_zoneOverlays = [];
        this.all_zonePolygons = [];
    }
    findMyLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async (position) => {
                const location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                const accuracy = position.coords.accuracy;
                await this.initialMap();
                this.addMarker(location);
                this.addCircle(location, accuracy);
            }, (e) => this.somethingWrongAlert$.next(e.message) //this.openSomethingWrongAlert(e.message)
            , {
                enableHighAccuracy: true
            });
        }
        else {
            this.somethingWrongAlert$.next('BrowserNotSupported');
            //this.openSomethingWrongAlert(this.utility.translate('BrowserNotSupported'));
        }
    }
    searchAddress(searchText) {
        if (searchText.trim().match(REGEX_LONG_LAT) == null) {
            //search for a place
            this.isCoordinatesSearch = false;
            this.setLoadingResults(true);
            this.googleAutocompleteService.getPlacePredictions({ input: searchText }, (predictions) => {
                this.setLoadingResults(false);
                this.setResultsSearched(predictions ?? []);
            });
        }
        else {
            //search for latitude & longitude
            this.isCoordinatesSearch = true;
            const prediction = {
                description: searchText,
                matched_substrings: [{ length: searchText.length, offset: 0 }],
                place_id: '',
                reference: '',
                types: [''],
                terms: [{ offset: 0, value: searchText }],
                structured_formatting: {
                    secondary_text: '',
                    main_text: searchText,
                    main_text_matched_substrings: [{ length: searchText.length, offset: 0 }],
                }
            };
            this.setResultsSearched([prediction]);
        }
    }
    async chooseAddress(item) {
        await this.initialMap();
        if (this.isCoordinatesSearch) {
            const lat = item.description.split(',')[0];
            const long = item.description.split(',')[1];
            const position = new google.maps.LatLng(+lat, +long);
            this.addMarker(position);
        }
        else {
            this.setResultsSearched([]);
            const request = { placeId: item.place_id };
            const service = new google.maps.places.PlacesService(this.map);
            service.getDetails(request, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK &&
                    place &&
                    place.geometry &&
                    place.geometry.location) {
                    this.addMarker(place.geometry.location);
                }
                else {
                    this.somethingWrongAlert$.next(status);
                    //this.openSomethingWrongAlert(status);
                }
            });
        }
    }
    geoCoderLatLang(position) {
        const request = {
            location: position,
            // language: this.utility.lang
        };
        this.geocoder
            .geocode(request, (results, status) => {
            this.resetAddress();
            if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
                //full address
                const fullAddress = this.getFullAddress(results);
                //extract
                const country = this.getCountries().find(co => co.twoLetterIsoCode === CountryIso2Code[fullAddress.countryCode]);
                if (country !== undefined) {
                    const countryOptions = country.options;
                    this.googleOptionsCountry = {
                        googleMapLevel1: countryOptions.googleMapLevel1,
                        googleMapLevel2: countryOptions.googleMapLevel2,
                        googleMapLevel3: countryOptions.googleMapLevel3,
                        googleMapLevel4: countryOptions.googleMapLevel4,
                        googleMapLevel5: countryOptions.googleMapLevel5,
                        googleMapLevel6: countryOptions.googleMapLevel6,
                    };
                    const googleOptionsExtracted = this.extractOptionKeys(fullAddress, this.googleOptionsCountry);
                    //mapping
                    this.mappingAddress(googleOptionsExtracted);
                }
                else if (!this.withZone) {
                    this.somethingWrongAlert$.next('CountryOutRange');
                    //this.openSomethingWrongAlert(this.utility.translate('CountryOutRange'), '');
                }
            }
            else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                this.somethingWrongAlert$.next('EmptySearchResults');
                //this.openSomethingWrongAlert(this.utility.translate('EmptySearchResults'));
            }
            else {
                this.somethingWrongAlert$.next(status);
                //this.openSomethingWrongAlert(status);
            }
        });
    }
    //#endregion
    //#region Reset
    resetMap() {
        this.resetMarker();
        this.resetCircles();
        this.address.accuracy = null;
    }
    resetMarker() {
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];
    }
    resetCircles() {
        this.circles.forEach(circle => circle.setMap(null));
        this.circles = [];
    }
    resetAddress() {
        this.fullAddress = {};
        Object.keys(this.fullAddress).forEach((key) => this.fullAddress[key] = null);
    }
    resetResults() {
        this.setResultsSearched([]);
    }
    //#endregion
    //#region Helpers
    displayMap() {
        this.elementHtml.style.display = 'block';
    }
    getFullAddress(results) {
        results.forEach(resultItem => resultItem.address_components.forEach((element) => this.populateAddressMapToAddress(element)));
        this.fullAddress.latitude = results[0].geometry.location.lat().toString();
        this.fullAddress.longitude = results[0].geometry.location.lng().toString();
        return this.fullAddress;
    }
    extractOptionKeys(fullAddress, googleOptions) {
        const addressKeys = Object.keys(fullAddress);
        const googleOptionKeys = Object.keys(googleOptions);
        googleOptionKeys.forEach((googleOptionKey) => {
            let googleOptionValue = googleOptions[googleOptionKey];
            if (googleOptionValue !== null && typeof googleOptionValue !== 'number') {
                //multiple item
                if (googleOptionValue.includes('/')) {
                    const mapKeys = googleOptionValue.split('/');
                    mapKeys.forEach((mapKey) => addressKeys.find((addressKey) => {
                        if (addressKey === mapKey && String(googleOptions[googleOptionKey]).includes('/') && googleOptions[googleOptionKey] !== '') {
                            googleOptions[googleOptionKey] = fullAddress[addressKey];
                        }
                    }));
                }
                //replace items between brackets forma address {premise}
                else if (googleOptionValue.match(REGEX_BRACKETS)) {
                    const mapKeys = googleOptionValue
                        .match(REGEX_BRACKETS_GLOBAL).join(' ')
                        .replace(REGEX_WITHOUT_BRACKETS, '').split(' ');
                    mapKeys.forEach((mapKey) => {
                        let value = null;
                        addressKeys.find((addressKey) => {
                            if (addressKey === mapKey) {
                                value = fullAddress[addressKey];
                            }
                        });
                        if (value) {
                            googleOptionValue = googleOptionValue.replace(REGEX_BRACKETS, value);
                        }
                        else {
                            if (String(googleOptionValue).match(REGEX_AFTER_COMMON_BRACKET)) {
                                googleOptionValue = googleOptionValue.replace(REGEX_AFTER_COMMON_BRACKET, '');
                            }
                            else {
                                googleOptionValue = googleOptionValue.replace(REGEX_BEFORE_COMMON_BRACKET, '');
                            }
                        }
                    });
                    googleOptions[googleOptionKey] = googleOptionValue;
                }
                //single item
                else {
                    addressKeys.find((addressKey) => {
                        if (addressKey === googleOptionValue) {
                            googleOptions[googleOptionKey] = fullAddress[addressKey];
                        }
                    });
                }
            }
        });
        googleOptions.countryIso = fullAddress.countryCode;
        googleOptions.latitude = fullAddress.latitude;
        googleOptions.longitude = fullAddress.longitude;
        return googleOptions;
    }
    mappingAddress(googleOptions) {
        this.address.countryId = this.getCountries().find((country) => country.twoLetterIsoCode === CountryIso2Code[googleOptions.countryIso]).id;
        this.address.stateProvinceId = null;
        this.address.stateProvinceName = googleOptions.googleMapLevel1;
        this.address.cityId = null;
        this.address.cityName = googleOptions.googleMapLevel2;
        this.address.districtId = null;
        this.address.zipPostalCode = googleOptions.googleMapLevel3;
        this.address.address1 = googleOptions.googleMapLevel4;
        this.address.address2 = googleOptions.googleMapLevel5;
        this.address.address3 = googleOptions.googleMapLevel6;
        this.address.longitude = googleOptions.longitude.toString();
        this.address.latitude = googleOptions.latitude.toString();
    }
    populateAddressMapToAddress(component) {
        this.checkAndPopulateAddressProp(component, 'country', this.fullAddress, 'country');
        this.checkAndPopulateAddressProp(component, 'country', this.fullAddress, 'countryCode', false, 'short_name');
        this.checkAndPopulateAddressProp(component, 'administrative_area_level_1', this.fullAddress, 'administrative_area_level_1');
        this.checkAndPopulateAddressProp(component, 'administrative_area_level_2', this.fullAddress, 'administrative_area_level_2');
        this.checkAndPopulateAddressProp(component, 'locality', this.fullAddress, 'locality', true, 'long_name');
        this.checkAndPopulateAddressProp(component, 'postal_code', this.fullAddress, 'postal_code');
        this.checkAndPopulateAddressProp(component, 'street_address', this.fullAddress, 'street_address');
        this.checkAndPopulateAddressProp(component, 'street_number', this.fullAddress, 'street_number');
        this.checkAndPopulateAddressProp(component, 'route', this.fullAddress, 'route', true);
        this.checkAndPopulateAddressProp(component, 'premise', this.fullAddress, 'premise');
        this.checkAndPopulateAddressProp(component, 'colloquial_area', this.fullAddress, 'colloquial_area');
        this.checkAndPopulateAddressProp(component, 'sublocality_level_1', this.fullAddress, 'sublocality_level_1');
    }
    checkAndPopulateAddressProp(mapComponent, mapType, address, addressProp, replace = false, mapProp = 'long_name') {
        if (mapComponent[mapProp] && mapComponent.types.includes(mapType) && (replace || !address[addressProp])) {
            address[addressProp] = mapComponent[mapProp];
        }
    }
}
GoogleMapsAppService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: GoogleMapsAppService, deps: [{ token: ScriptService }], target: i0.ɵɵFactoryTarget.Injectable });
GoogleMapsAppService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: GoogleMapsAppService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: GoogleMapsAppService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ScriptService }]; } });

/*
 * Public API Surface of ng.core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GoogleMapsAppService, NgCoreModule, NgCoreService, ScriptLibraryType, ScriptService, scriptLibs };
